console.log("Etsy Feed Loaded");

document.addEventListener("DOMContentLoaded", () => {

    const grid = document.querySelector(".etsy-feed-grid");
const carousel = document.querySelector(".etsy-feed-carousel .swiper-wrapper");

const container = grid || carousel;

if (!container) return;

const isCarousel = !!carousel;

    container.innerHTML = `
<div class="etsy-loading">
    Loading latest Etsy products...
</div>
`;

    const rssUrl = "https://www.etsy.com/shop/abhirajknitatelier/rss";

const apiUrl =
    `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(rssUrl)}&t=${Date.now()}`;

fetch(apiUrl, {
    cache: "no-store"
})
        .then(res => res.json())
        .then(data => {

            console.log(data);

            container.innerHTML = "";

        data.items.forEach(item => {

    const img =
        item.thumbnail ||
        (item.description.match(/<img.*?src="(.*?)"/)?.[1] || "");

    const price =
    item.description.match(/<p class="price">(.*?)<\/p>/)?.[1] || "See Etsy";

    const title = item.title
        .replace(/by AbhirajKnitAtelier/gi, "")
        .replace(/&amp;#39;/g, "'")
        .trim();

    container.insertAdjacentHTML("beforeend", `

       ${isCarousel ? '<div class="swiper-slide">' : ''}

<article class="etsy-card etsy-hidden">

           <a
    href="${item.link}"
    target="_blank"
    rel="noopener noreferrer"
    class="etsy-card-link"
>

                <div class="etsy-image">

    <img
        src="${img}"
        alt="${title}"
        loading="lazy"
    >

    <div class="etsy-overlay">

        <span class="etsy-badge">
            Etsy
        </span>

        <span class="etsy-view">
            View Product →
        </span>

    </div>

</div>

               <div class="etsy-content">

    <span class="etsy-label">

        Etsy Exclusive

    </span>

    <h3>${title}</h3>

    <div class="etsy-price">

        ${price}

    </div>

                    <button class="etsy-btn">

                        View on Etsy →

                    </button>

                </div>

            </a>

        </article>
        ${isCarousel ? '</div>' : ''}

    `);

});

const cards = container.querySelectorAll(".etsy-card");

if (cards.length) {
    cards.forEach((card, index) => {
        setTimeout(() => {
            card.classList.add("etsy-show");
        }, index * 80);
    });
}

if (isCarousel) {

    new Swiper(".etsy-feed-carousel", {

        slidesPerView: 4,
        spaceBetween: 30,

        loop: true,

        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },

        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },

        breakpoints: {

            0: {
                slidesPerView: 1.2,
                spaceBetween: 16
            },

            576: {
                slidesPerView: 2,
                spaceBetween: 20
            },

            992: {
                slidesPerView: 3,
                spaceBetween: 24
            },

            1200: {
                slidesPerView: 4,
                spaceBetween: 30
            }

        }

    });

}
        })
        .catch(error => {

    console.error(error);

    container.innerHTML = `

        <div class="etsy-error">

            <h3>Oops!</h3>

            <p>
                We couldn't load our latest Etsy products right now.
            </p>

            <a
                href="https://www.etsy.com/shop/AbhirajKnitAtelier"
                target="_blank"
                class="etsy-shop-btn"
            >
                Visit Our Etsy Shop →
            </a>

        </div>

    `;

});

});